import Assets from './assets';
import AssetEdit from './asset_edit';
import AssetAdd from './asset_add';
import AssetView from './asset_view';

export {
  Assets,
  AssetEdit,
  AssetAdd,
  AssetView
};
